// extracted by mini-css-extract-plugin
export var logo = "_km-2";
export var logoWrapper = "_km-1";
export var strip = "_km-0";